import apiConfig from "../../apiConfig";

export const deleteType = async (at, typeId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Types/Delete_Donation_Type",
		{
			Donation_Type_Id: typeId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	// if (response.data.Status) {
	// 	return response.data;
	// }

	// return [];
	return response.data;
};
